module.exports = __webpack_public_path__ + "img/IMG_20190127_174023.edae8c43.jpg";